enum integrationTypes {
	MenuItemKey = 'menuItemKey',
	MyTasks = 'myTasks',
	BygoneTasks = 'bygoneTasks'
}

export { integrationTypes };
